import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import Footer from '../Footer';
import MessageReceiver from '../MessageReceiver';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {makeStyles} from "@material-ui/core/styles";
import MainMenu from "../MainMenu";
import {amInPopup} from "../../../utils/utils";

const useStyles = makeStyles(theme => ({
    app: {
        minHeight: 430,
    },
    popupApp: {
        minHeight: 100,
        padding: 0,
        '& .MuiContainer-root': {
            padding: 0,
        }
    },
}));

const App = () => {
    const classes = useStyles();

    return (
        <Router>
            <div id="appRouter" className={amInPopup() ? classes.popupApp : classes.app}>
                <MessageReceiver/>
                <Route path="/" component={MainMenu}/>
                <Footer/>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
            </div>
        </Router>
    )
};

export default App;
